import {injectable} from "inversify";
import {CompanyEntity} from "@dropDesk/domain/entities/company/company.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ChatIntegrationConnectionEntity} from "@dropDesk/domain/entities/chat/chat_integration_connection.entity";
import {PaymentStatus} from "@dropDesk/domain/entities/payment/payment.enum";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {BaileysVersionEntity} from "@dropDesk/domain/entities/chat/baileys_version.entity";

@injectable()
export abstract class PanelAdmRepository {
    public abstract getCompanyBySearch(search: string): Promise<{company: CompanyEntity, user:UserEntity}>;

    public abstract removeCompanyCache(idCompany: string): Promise<void>;

    public abstract chatConnectionState(idCompany: string): Promise<ChatIntegrationConnectionEntity>;

    public abstract listPayments(page: number, limit: number, idCompany: string, status?: PaymentStatus): Promise<ListPaginationEntity<PaymentEntity>>;

    public abstract refund(idExternal: string, id: string): Promise<void>;

    public abstract externallyPay(idExternal: string, id: string): Promise<void>;

    public abstract allowSubscriptionUpgrade(idCompany: string, idSubscription: string): Promise<void>;

    public abstract getBaileysVersion(): Promise<BaileysVersionEntity>;

    public abstract updateBaileysVersion(version: string): Promise<BaileysVersionEntity>;
}
